import React, { useState } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Link } from "react-router-dom";

import logo from "../assets/img/LogoFree.svg";
import "../assets/css/cs.css";

const meta = {
  title: "Privacy Policy - Logy.AI",
  meta: [],
  link: [],
  style: [],
  script: [],
};

export default function Privacy() {
  const [menu, setMenu] = useState(true);
  const toggleMenu = () => {
    setMenu(!menu);
  };

  return (
    <React.Fragment>
      <HelmetProvider>
        <Helmet {...meta}></Helmet>
      </HelmetProvider>
      <section className="pt-6 bg-gray-50 overflow-hidden pb-6">
        <div className="container mx-auto px-4">
          <div className="mb-1">
            <div className="flex items-center justify-between px-6 py-3.5 bg-white border border-gray-100 rounded-full">
              <div className="w-auto">
                <div className="flex flex-wrap items-center">
                  <div className="w-auto">
                    <Link className="inline-block" to="/">
                      <img
                        src={logo}
                        style={{
                          width: "100px",
                          transform: "translateY(3px) translateX(10px)",
                        }}
                        alt=""
                      />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="w-auto">
                <div className="flex flex-wrap items-center">
                  <div className="w-auto hidden lg:block">
                    <ul className="flex items-center justify-center ">
                      <li className="  ">
                        <Link
                          className=" inline-block px-6 text-sm font-bold text-gray-900 hover:text-gray-700  "
                          to="/"
                        >
                          Home
                        </Link>
                      </li>
                      <li className="">
                        <Link
                          className=" inline-block px-6 text-sm font-bold text-gray-900 hover:text-gray-700 "
                          to="/about"
                        >
                          About us
                        </Link>
                      </li>
                      <li className="">
                        <Link
                          className="inline-block px-6 text-sm font-bold text-gray-900 hover:text-gray-700"
                          to="/products"
                        >
                          Products
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="inline-block px-6 text-sm font-bold text-gray-900 hover:text-gray-700"
                          to="/articles"
                        >
                          Articles
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="inline-block px-6 text-sm font-bold text-gray-900 hover:text-gray-700"
                          to="/cases"
                        >
                          Case Studies
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="w-auto">
                <div className="flex flex-wrap items-center">
                  <div className="w-auto hidden lg:block">
                    <div className="flex flex-wrap -m-2">
                      <div className="w-full md:w-auto p-2" />
                      <div className="w-full md:w-auto p-2">
                        <Link
                          className="block w-full px-4 py-2.5 text-sm text-center text-white font-bold bg-blue-500 hover:bg-blue-600 focus:ring-4 focus:ring-blue-200 rounded-full"
                          to="/contact"
                        >
                          Get in Touch
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="w-auto lg:hidden">
                    <a className="inline-block" onClick={toggleMenu}>
                      <svg
                        className="navbar-burger text-blue-500"
                        width={45}
                        height={45}
                        viewBox="0 0 56 56"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          width={56}
                          height={56}
                          rx={28}
                          fill="currentColor"
                        />
                        <path
                          d="M37 32H19M37 24H19"
                          stroke="white"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div
              className=" navbar-menu fixed top-0 left-0 bottom-0 w-4/6 sm:max-w-xs z-50"
              hidden={menu}
            >
              <div className="navbar-backdrop fixed inset-0 bg-gray-800 opacity-80" />
              <nav className="relative z-10 px-9 pt-8 bg-white h-full overflow-y-auto">
                <div className="flex flex-wrap justify-between h-full">
                  <div className="w-full">
                    <div className="flex items-center justify-between -m-2">
                      <div className="w-auto p-2">
                        <Link className="inline-block" to="/">
                          <img src={logo} style={{ width: "90px" }} alt="" />
                        </Link>
                      </div>
                      <div className="w-auto p-2">
                        <a
                          className="inline-block navbar-burger"
                          onClick={toggleMenu}
                        >
                          <svg
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6 18L18 6M6 6L18 18"
                              stroke="#111827"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col justify-center py-8 w-full">
                    <ul>
                      <li className="mb-9">
                        <Link
                          className="inline-block text-sm font-bold text-gray-900 hover:text-gray-700"
                          to="/"
                        >
                          Home
                        </Link>
                      </li>
                      <li className="mb-9">
                        <Link
                          className="inline-block text-sm font-bold text-gray-900 hover:text-gray-700"
                          to="/about"
                        >
                          About us
                        </Link>
                      </li>
                      <li className="mb-9">
                        <Link
                          className="inline-block text-sm font-bold text-gray-900 hover:text-gray-700"
                          to="products"
                        >
                          Products
                        </Link>
                      </li>
                      <li className="mb-9">
                        <Link
                          className="inline-block text-sm font-bold text-gray-900 hover:text-gray-700"
                          to="/articles"
                        >
                          Articles
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="inline-block text-sm font-bold text-gray-900 hover:text-gray-700"
                          to="/cases"
                        >
                          Case Studies
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div className="flex flex-col justify-end w-full pb-8">
                    <div className="flex flex-wrap -m-2">
                      <div className="w-full p-2">
                        <Link
                          className="block w-full px-4 py-2.5 text-sm text-center text-white font-bold bg-blue-500 hover:bg-blue-600 focus:ring-4 focus:ring-blue-200 rounded-full"
                          to="/contact"
                        >
                          Get in Touch
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-gray-50 pb-12">
        <div className="container mx-auto px-4 md:px-8 lg:px-16 max-w-6xl">
          <div className="bg-white rounded-lg shadow-md p-8 md:p-12">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8">
              Privacy Policy
            </h1>

            <p className="text-gray-600 mb-8">
              <strong>Effective Date:</strong> January 1, 2026
            </p>

            <div className="space-y-8 text-gray-700">
              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Introduction</h2>
                <p className="leading-relaxed">
                  Logy.AI ("we", "us", or "our") is committed to protecting your privacy.
                  This Privacy Policy explains how we collect, use, disclose, and safeguard your information when
                  you use our AI-powered healthcare platform and related services. Some services are consumer
                  screening programs that we provide on behalf of a client. For those programs, the client determines
                  the purpose of the processing, and we process personal
                  data only on its documented instructions, except where otherwise required by law.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Information We Collect</h2>
                <h3 className="text-xl font-semibold text-gray-800 mb-3">2.1 Personal Information</h3>
                <p className="leading-relaxed mb-4">
                  We may collect personal information that you voluntarily provide to us, including:
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Name, phone number, email address, age, and other contact information</li>
                  <li>Professional credentials and organizational affiliation</li>
                  <li>Account login credentials</li>
                  <li>Questionnaire responses, including oral hygiene habits</li>
                </ul>

                <h3 className="text-xl font-semibold text-gray-800 mb-3 mt-6">2.2 Sensitive Health Information</h3>
                <p className="leading-relaxed mb-4">
                  When you use our screening or diagnostic tools, we may collect sensitive health information,
                  including:
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Oral photographs and other medical images</li>
                  <li>Oral health risk scores, reports, and related screening data</li>
                  <li>Health-related information necessary for AI analysis</li>
                  <li>Treatment and diagnosis records (when applicable)</li>
                </ul>

                <h3 className="text-xl font-semibold text-gray-800 mb-3 mt-6">2.3 Usage Data</h3>
                <p className="leading-relaxed">
                  We automatically collect information about your interaction with our platform, including device
                  information, IP address, browser type, and usage patterns.
                </p>

                <h3 className="text-xl font-semibold text-gray-800 mb-3 mt-6">2.4 How We Collect Information</h3>
                <p className="leading-relaxed">
                  We may collect information directly from you through a web application, messaging chatbot, or
                  another program interface. For a client screening program, we collect this information on behalf
                  of the client.
                </p>
                <p className="leading-relaxed mt-4">
                  We may also provide the technical interface through which the client presents a
                  privacy notice and collects a user's permission or acknowledgment. Depending on the applicable
                  requirements, this may include a consent form, checkbox, policy-acceptance step, acknowledgment, or
                  another appropriate mechanism. We record and maintain the resulting consent or acknowledgment on the
                  client's behalf and according to its documented instructions.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">3. How We Use Your Information</h2>
                <p className="leading-relaxed mb-4">We use collected information to:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Provide and operate our AI-powered screening and diagnostic services</li>
                  <li>Analyze oral photographs, medical images, and questionnaire responses</li>
                  <li>Identify indicators associated with decay, stains, calculus, gum issues, and other conditions</li>
                  <li>Generate personalized health risk scores and reports</li>
                  <li>Communicate with you about our services</li>
                  <li>Ensure platform security and prevent fraud</li>
                  <li>Comply with legal and regulatory requirements</li>
                </ul>
                <p className="leading-relaxed mt-4">
                  Personal data collected through a client screening program is used only to provide the contracted
                  service on the client's behalf.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Automated Processing</h2>
                <p className="leading-relaxed mb-4">
                  Our platform uses AI techniques to analyze health images and questionnaire responses and generate
                  a personalized risk score and report. This automated analysis is a core part of the service.
                </p>
                <p className="leading-relaxed">
                  Screening results provide health risk information and are not a medical diagnosis. They do not
                  independently determine treatment or access to healthcare. You should consult a qualified healthcare
                  professional about any health concern or before making a treatment decision.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Data Security and Governance</h2>
                <p className="leading-relaxed">
                  We use administrative, physical, and technical safeguards designed to protect personal data,
                  including encryption, secure cloud infrastructure, access controls, and monitoring. Personnel with
                  access to personal data are subject to confidentiality obligations, company policies, and regular
                  privacy and security training. Our privacy and security program is assessed periodically through
                  internal and external reviews against recognized information security standards.
                </p>
                <p className="leading-relaxed mt-4">
                  We maintain a documented incident response plan covering detection, containment, notification, and
                  remediation. If a personal data incident affects a client program, we will notify the client and
                  relevant authorities as required by contract and applicable law. No security measure
                  can eliminate every risk, and we cannot guarantee absolute security.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Data Sharing and Disclosure</h2>
                <p className="leading-relaxed mb-4">
                  We do not sell personal or health information and do not share it for cross-context behavioral
                  advertising. For a client screening program, we disclose personal data only to:
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>The client on whose behalf we provide the service</li>
                  <li>Approved service providers supporting hosting, storage, security, communications, or operations</li>
                  <li>Legal authorities when required by law</li>
                </ul>
                <p className="leading-relaxed mt-4">
                  Service providers are assessed before engagement and on an ongoing basis. They are contractually
                  required to protect personal data and may process it only to provide services to us, not for their
                  own purposes.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Your Rights</h2>
                <p className="leading-relaxed mb-4">You have the right to:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Access and review your personal information</li>
                  <li>Request correction of inaccurate data</li>
                  <li>Request deletion of your data (subject to legal obligations)</li>
                  <li>Opt-out of certain data processing activities</li>
                  <li>Ask questions about automated processing and screening results</li>
                </ul>
                <p className="leading-relaxed mt-4">
                  If we receive a request or inquiry relating to a client program, we will notify the client where
                  permitted and assist it in responding. 
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">8. International Data Transfers</h2>
                <p className="leading-relaxed">
                  Personal data may be accessed, processed, or stored in India and the United States, including on
                  secure cloud infrastructure. If data is transferred outside your country of residence, we use
                  appropriate contractual, organizational, and technical safeguards in accordance with applicable
                  data protection law.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Children's Privacy</h2>
                <p className="leading-relaxed mb-4">
                  Some client screening programs may be available to individuals under 18. Before a minor's data is
                  collected, the client is responsible for providing required notices and
                  obtaining legally valid consent from a parent or guardian where required by applicable law. We may
                  provide and operate the form or other technical mechanism used by the client to
                  collect and record that consent.
                </p>
                <p className="leading-relaxed">
                  We process a minor's personal data only after the client confirms that appropriate
                  consent and safeguards are in place. A policy acknowledgment alone is not treated as consent where
                  affirmative or verifiable consent is required. We apply age-appropriate protections and do not use a
                  minor's personal data for advertising, unrelated profiling, or any purpose independent of the
                  client screening service.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Data Retention and Deletion</h2>
                <p className="leading-relaxed">
                  We retain personal data only for as long as necessary to provide the service, follow the client's
                  documented instructions, and meet applicable legal obligations. At the end of a contract, or earlier
                  at the client's request, we will return or securely delete client-program personal data from active
                  systems. Residual encrypted backup copies are isolated
                  from normal use and deleted through controlled backup-expiration schedules, unless limited retention
                  is required by law.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">11. Changes to This Policy</h2>
                <p className="leading-relaxed">
                  We may update this Privacy Policy from time to time. We will notify you of material changes by
                  posting the updated policy on our website and changing the effective date.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">12. Contact Us</h2>
                <p className="leading-relaxed mb-4">
                  We have appointed a Data Protection Officer. To ask a privacy question, exercise your rights, or
                  contact our Data Protection Officer, please use the details below:
                </p>
                <div className="bg-gray-50 p-6 rounded-lg">
                  <p className="font-semibold mb-2">Logy.AI</p>
                  <p className="mt-4">
                    Email: <a href="mailto:regulatory@logy.ai" className="text-blue-500 hover:text-blue-600">regulatory@logy.ai</a>
                  </p>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
}
